<template>
  <!-- eslint-disable vue/no-parsing-error -->
  <!-- Pickup Form for add/update pickup and dropoffs-->
    <div class="inner-left">
      <Form :inline="true" class="form-default" :disabled="transporterPaneOpen">
        <Tooltip :open-delay="100" effect="dark" placement="bottom" v-if="!isHideAllActions && !isHideEditDropOffSource && !transporterPaneOpen">
          <div slot="content">{{$t('INDENT_DELETE_GATE')}}</div>
          <i class="action-icon" @click="$emit('deletePickup')">
            <svgicon name="icon-delete-md" width="14" height="14"/>
          </i>
        </Tooltip>
        <Row>
          <Col :class="{'col-w-100': transporterPaneOpen, 'col-w-25': !transporterPaneOpen }" :lg="6" v-if="showPickups">
            <FormItem :label="$t('INDENT_GATE')" required>
              <span class="form-value" v-if="isHideAllActions || isHideEditDropOffSource">
                {{searchListById(list, data.id).name}}
              </span>
              <Select
                v-else
                :value="data.id"
                filterable
                class="select-default"
                @change="changeData($event,'id')">
                <Option
                  v-for="item in list"
                  :key="item.id"
                  :label="`${item.reference_id} - ${item.name}`"
                  :value="item.id"
                  :disabled="isAlreadySelectedGate(item.id)"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col :class="{'col-w-100': transporterPaneOpen, 'col-w-25': !transporterPaneOpen }" :lg="7" :xl="6">
            <FormItem :label="$t('INDENT_VEHICLE_REQUIREMENT_DATE')" required>
              <Date-Picker
                :disabled="isHideAllActions"
                :value="data.vehicle_requirement_date || new Date()"
                :clearable="false"
                :picker-options="pickerOptionsVRD"
                :format="datePickerFormat"
                type="datetime"
                placeholder="Select date and time"
                @input="changeData($event,'vehicle_requirement_date')">
              </Date-Picker>
            </FormItem>
          </Col>
          <Col :class="{'col-w-100': transporterPaneOpen, 'col-w-50': !transporterPaneOpen }" :lg="8" :xl="7" v-if="!$hasFeature('docks')">
            <div class="list-form-switch ml-20">
              <label>{{$t('INDENT_LOADERS')}}</label>
              <SwitchBtn
                :disabled="isHideAllActions"
                :value="data.loader_available || false"
                align="top"
                size="small"
                label="right"
                :active-text="$t('INDENT_YES')"
                :inactive-text="$t('INDENT_NO')"
                class="default-switch"
                @change="changeData($event,'loader_available')"
              />
            </div>
            <div class="list-form-switch ml-20">
              <label>{{$t('INDENT_ADD_INVOICE')}}</label>
              <SwitchBtn
                :disabled="isHideAllActions"
                :value="data.add_to_invoice || false"
                align="top"
                size="small"
                label="right"
                :active-text="$t('INDENT_YES')"
                :inactive-text="$t('INDENT_NO')"
                class="default-switch"
                @change="changeData($event,'add_to_invoice')"
              />
            </div>
          </Col>
          </Row>
          <Row>
          <Col :lg="6" :class="{'col-w-100': transporterPaneOpen, 'col-w-25': !transporterPaneOpen }" v-if="selectedOrderType === 'CONTRACT' && isEditState && checkIfTruckAssigned && index === 0 && isAutoSwitchEnabled">
            <FormItem :disabled="autoSwitchExtendedOnce" :label="'Extend Sla time by (hrs)'">
              <span class="form-value" v-if="isHideAllActions || isHideEditDropOffSource">
                {{searchListById(list, data.id).name}}
              </span>
              <Select
                v-else
                :disabled="autoSwitchExtendedOnce"
                v-model="extendSlaBy"
                filterable
                @change="emitSlaChange"
                class="select-default">
                <Option
                  :selected="!extendSlaBy"
                  :label="'Do not Extend'"
                  :value="0"
                ></Option>
                <Option
                  v-for="item in 24"
                  :key="item"
                  :label="item"
                  :value="item"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col :lg="7" :class="{'col-w-100': transporterPaneOpen, 'col-w-30': !transporterPaneOpen }" v-if="showPickups && hasDocks && dockList.length">
            <FormItem :label="$t('INDENT_DOCKS')">
              <span class="form-value" v-if="isHideAllActions || isHideEditDropOffSource">
                {{searchMultipleListById(dockList, data.dockId)[0].name}}
              </span>
              <Select
                v-else
                v-model="data.dockId"
                filterable clearable multiple
                collapse-tags
                collapse-tags-tooltip
                class="select-default"
                @change="changeData($event,'id', true)">
                <Option
                  v-for="item in dockList"
                  :key="item.id"
                  :label="`${item.reference_id} - ${item.name}`"
                  :value="item.id" />
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div
        v-if="!(showPickups && !data.id)"
        class="mt-10"
        :class="{'table-with-add': !isHideAllActions && !isHideEditDropOffSource}">

        <div
          :class="{'event-disabler': transporterPaneOpen}"
          @click="openDropOffSlider"
          v-if="!isHideAllActions && !isHideEditDropOffSource"
          class="add-block">
          {{$t('INDENT_ADD')}}<span v-if="!noDropoffsExist">/{{$t('INDENT_EDIT')}}</span> {{$t('INDENT_DROP_OFF')}}
        </div>

        <Table
          :data="data.dropoffs"
          :stripe="true"
          ref="tableref"
          empty-text="No data"
          class="table-striped bordered"
          aria-describedby="pickUpFormData"
          >
          <table-column
            :label="$t('INDENT_SHIP_TO')"
            >
            <template slot-scope="scope">
              <span class="d-block">
                <Ellipsis
                  v-if="scope.row.ship_to.name"
                  :text="scope.row.ship_to.name"
                  length="18"/>
              </span>
              <span class="text-xs" v-if="scope.row.ship_to.reference_id">
                <Ellipsis
                  :text="scope.row.ship_to.reference_id"
                  length="18"/>
              </span>
            </template>
          </table-column>
          <table-column
            :label="$t('INDENT_SOLD_TO')"
          >
            <template slot-scope="scope">
              <span class="d-block">
                <Ellipsis
                  v-if="scope.row.sold_to.name"
                  :text="scope.row.sold_to.name"
                  length="18"/>
              </span>
              <span class="text-xs" v-if="scope.row.sold_to.reference_id">
                <Ellipsis
                  :text="scope.row.sold_to.reference_id"
                  length="18"/>
              </span>
            </template>
          </table-column>
          <table-column
            v-if="currentOrderTypeConfig && !currentOrderTypeConfig.hide_unloaders"
            :label="$t('INDENT_UNLOADERS')"
            width="100">
            <template slot-scope="scope">
              <div v-if="isHideAllActions">
                {{searchListById(unloadersList, scope.row.unloader_available, 'value').label}}
              </div>
              <Select
                v-else
                :disabled="transporterPaneOpen"
                v-model="scope.row.unloader_available"
                size="mini"
                class="select-default no-bg ml-m10"
                @input="changeDropoffData($event, scope.row,'unloader_available')">
                <Option
                  v-for="item in unloadersList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                ></Option>
              </Select>
            </template>
          </table-column>
          <table-column
            v-if="currentOrderTypeConfig && !currentOrderTypeConfig.hide_paid_by"
            :label="$t('INDENT_PAID_BY')"
            width="100">
            <template slot-scope="scope">
              <div v-if="isHideAllActions">
                {{searchListById(paidByList, scope.row.add_to_invoice, 'value').label}}
              </div>
              <Select
                v-else
                v-model="scope.row.add_to_invoice"
                size="mini"
                class="select-default no-bg ml-m10"
                :disabled="transporterPaneOpen"
                @input="changeDropoffData($event, scope.row,'add_to_invoice')">
                <Option
                  v-for="item in paidByList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                ></Option>
              </Select>
            </template>
          </table-column>
          <table-column
            v-if="currentOrderTypeConfig && !currentOrderTypeConfig.hide_expected_date"
            :label="$t('INDENT_EXPECTED_DATE')"
            width="110">
            <template slot-scope="scope">
              <Date-Picker
                :disabled="isHideAllActions || transporterPaneOpen"
                :picker-options="pickerOptions"
                v-model="scope.row.expected_date"
                type="date"
                border="none"
                placeholder="Enter Date"
                class="date-plain no-bg"
                @input="changeDropoffData($event, scope.row,'expected_date')">
            </Date-Picker>
            </template>
          </table-column>
          <table-column
            width="30"
            v-if="!transporterPaneOpen">
            <template slot-scope="scope" v-if="scope.row &&
            scope.row.ship_to && scope.row.ship_to.type ==2">
              <Tooltip :open-delay="100" effect="dark" placement="top">
                <div slot="content">{{$t('INDENT_EDIT_CONSIGNEE')}}</div>
                <i class="action-row" @click="$emit('editConsignee', scope.row)">
                  <svgicon name="icon-edit-md" width="14" height="14"/>
                </i>
              </Tooltip>
            </template>
          </table-column>
          <table-column
            width="30"
            v-if="!isHideAllActions && !isHideEditDropOffSource && !transporterPaneOpen">
            <template slot-scope="scope">
              <div class="custom-popover" v-if="showDeletePrompt &&
                scope.$index === currentSelectedShipToId">
                {{$t('INDENT_DELETE_DROPOFF')}}?
                <span class="text-bold ml-5">
                  <span class="d-inline pointer" @click="deleteDropoff(scope.row)">{{$t('INDENT_YES')}}</span>
                  /
                  <span class="d-inline pointer" @click="clearDeleteDropOffConfirmation">{{$t('INDENT_NO')}}</span>
                </span>
              </div>
              <Tooltip :open-delay="100" effect="dark" placement="top">
                <div slot="content">{{$t('INDENT_DELETE')}}</div>
                <i class="action-row" @click ="currentSelectedShipToId = scope.$index;showDeletePrompt = true">
                  <svgicon name="icon-delete-md" width="14" height="14"/>
                </i>
              </Tooltip>
            </template>
          </table-column>
        </Table>
      </div>
  </div>
</template>

<script>
import { orderTypes, unloadersList, paidByList } from '@/modules-v2/indent/constants/order';
import {
  movementType, orderType,
} from 'pando-constants';


export default {
  data() {
    return {
      unloadersList,
      paidByList,
      showDeletePrompt: false,
      currentSelectedShipToId: null,
      movementType,
    };
  },
  props: {
    transporterPaneOpen: {
      default: false,
      type: Boolean,
    },
    orderMovement: {
      default: 2,
      type: Number,
    },
    selectedOrderDeliveryType: {
      default: 'FTL',
      type: String,
    },
    clientConfig: {
      default: () => ({}),
      type: Object,
    },
    extendSlaBy: {
      default: 0,
      type: Number,
    },
    autoSwitchExtendedOnce: {
      default: false,
      type: Boolean,
    },
    index: {
      type: Number,
    },
    data: {
      default: () => ({}),
      type: Object,
    },
    depot: {
      default: () => ({}),
      type: Object,
    },
    list: {
      default: () => ([]),
      type: Array,
    },
    selectedOrderType: {
      default: '',
      type: String,
    },
    selectedGateIds: {
      default: () => ([]),
      type: Array,
    },
    showPickups: {
      default: false,
      type: Boolean,
    },
    isHideAllActions: {
      default: false,
      type: Boolean,
    },
    isHideEditDropOffSource: {
      default: false,
      type: Boolean,
    },
    destinationConfig: {
      default: () => ([]),
      type: Array,
    },
    slaJobData: {
      type: Object,
      default: () => ({}),
    },
    datePickerFormat: {
      type: String,
      default: 'dd-MM-yyyy hh:mm A',
    },
    isEditState: {
      type: Boolean,
      default: false,
    },
    selectedOrderStatus: {
      type: Number,
    },
  },
  created() {
    if (this.data.id && this.data.dockId && this.data.dockId.length) {
      const currentDockIds = this.dockList
        .filter(dock => (this.data.dockId && this.data.dockId.includes(dock.id)));
      this.data.dockId = currentDockIds.map(_dock => _dock.id.toString());
    }
  },
  computed: {
    isAutoSwitchEnabled() {
      const autoSwitchConfig = this.clientConfig.auto_switch_transporter;
      if (this.selectedOrderDeliveryType === 'FTL' && autoSwitchConfig
      && autoSwitchConfig.is_enabled_for_ftl && autoSwitchConfig.auto_switch_on_sla_breach) {
        return (this.orderMovement === this.movementType.SECONDARY && autoSwitchConfig.is_enabled_for_secondary) ||
        (this.orderMovement === this.movementType.PRIMARY && autoSwitchConfig.is_enabled_for_primary) ||
        (this.orderMovement === this.movementType.INWARD && autoSwitchConfig.is_enabled_for_inward) ||
        (this.orderMovement === this.movementType.RETURNS && autoSwitchConfig.is_enabled_for_return);
      }
      return false;
    },
    hasDocks() {
      return this.$hasFeature('docks') && this.$hasPermission('indent_add_docks');
    },
    dockList() {
      return this.$depot.docksByGate(this.data.id, this.depot.id);
    },
    noDropoffsExist() {
      return !this.data.dropoffs || !this.data.dropoffs.length;
    },
    currentOrderTypeConfig() {
      const config = orderTypes.find(val => val.name === this.selectedOrderType);
      return (config && config.dropoffs_columns_config) || {};
    },
    pickerOptions() {
      const loadingDate = new Date(this.$moment(this.data.vehicle_requirement_date)) || new Date();
      if (orderType[this.selectedOrderType] === 1) {
        loadingDate.setHours(0, 0, 0, 0);
      }
      return {
        disabledDate(time) {
          if (loadingDate) {
            return time.getTime() < loadingDate.getTime();
          }
        },
      };
    },
    pickerOptionsVRD() {
      const slaBreachDate = this.slaJobData.sla_breach_at;
      return {
        disabledDate(time) {
          const slaBreachAt = new Date(slaBreachDate).getTime();
          const currentTime = new Date().getTime();
          return slaBreachAt < currentTime;
        },
      };
    },
    checkIfTruckAssigned() {
      return (this.$statusUtil.getMainStatusName(this.selectedOrderStatus) === 'truck_assigned');
    },
  },
  methods: {
    emitSlaChange(data) {
      this.$emit('sla-change', data);
    },
    // change the pickup specific data

    changeData(data, key, isDock = false) {
      const newPickupDetail = { ...this.data };
      if (key === 'vehicle_requirement_date') {
        this.$emit('setGA', 'Click', 'Change Vehicle Requirement Date or Time');
      }
      if (key === 'id') {
        if (isDock) {
          newPickupDetail.dockId = data;
        } else {
          const pickUp = this.list.find(val => val.id === data);
          newPickupDetail.id = pickUp.id;
          newPickupDetail.reference_id = pickUp.reference_id;
          newPickupDetail.name = pickUp.name;
          delete newPickupDetail.dockId;
        }
      } else {
        newPickupDetail[key] = data;
      }
      this.$emit('changePickupData', newPickupDetail);
    },
    isAlreadySelectedGate(gateId) {
      return this.selectedGateIds.some(val => val === gateId);
    },
    // change the dropoff data
    changeDropoffData(value, row, key) {
      const index = this.data.dropoffs.findIndex((val) => {
        if (val.indexedAt && row.indexedAt) {
          return val.indexedAt === row.indexedAt;
        }
        return val.index === row.index;
      });
      this.data.dropoffs[index][key] = value;
      this.$emit('addEditDropoffs', this.data.dropoffs);
    },
    openDropOffSlider() {
      if (!this.transporterPaneOpen) {
        this.$emit('setGA', 'Click', 'Edit Drop-Off');
        this.clearDeleteDropOffConfirmation();
        if (!(this.showPickups && !this.data.id)) {
          this.$emit('openDropoffSlider');
        }
      }
    },

    searchListById(list, id, keyToMatch = 'id') {
      return list.find(val => val[keyToMatch] === id);
    },

    searchMultipleListById(list, ids) {
      return list.filter(val => val.dockId.includes(ids));
    },

    deleteDropoff(dropOffData) {
      this.clearDeleteDropOffConfirmation();
      return this.$emit('deleteDropoff', dropOffData);
    },

    clearDeleteDropOffConfirmation() {
      this.currentSelectedShipToId = null;
      this.showDeletePrompt = false;
    },

  },
};
</script>
